import { URLS } from "../../env/urls";
import { sendServerRequest } from "../../server/request";
import { SCRIPT1_STATES, SCRIPT2_STATES } from "../../components/adm/bulkstate/states";

export type ScriptKey = 'script1' | 'script2';

export interface ServerStates {
  script1: string[];
  script2: string[];
}

// Fallback local (usado só se o servidor não responder). A fonte de verdade são
// os enums do backend, expostos em /server/chatsinfo/states.
const FALLBACK: ServerStates = { script1: SCRIPT1_STATES, script2: SCRIPT2_STATES };

let cache: ServerStates | undefined;
let inFlight: Promise<ServerStates> | undefined;

/**
 * Busca os estados dos scripts no servidor (com cache em memória). Assim, se um
 * estado novo for criado no backend, ele aparece no front sem precisar editar
 * nada aqui. Cai no fallback local em caso de erro de rede.
 */
export async function getServerStates(): Promise<ServerStates> {
  if (cache) return cache;
  if (inFlight) return inFlight;
  inFlight = sendServerRequest('GET', URLS.chatsInfo.states)
    .then((e) => {
      const data = e.data?.data;
      const result: ServerStates = {
        script1: Array.isArray(data?.script1) && data.script1.length ? data.script1 : FALLBACK.script1,
        script2: Array.isArray(data?.script2) && data.script2.length ? data.script2 : FALLBACK.script2,
      };
      cache = result;
      inFlight = undefined;
      return result;
    })
    .catch(() => {
      inFlight = undefined;
      return FALLBACK;
    });
  return inFlight;
}

export function statesForScript(states: ServerStates, script: ScriptKey): string[] {
  return script === 'script1' ? states.script1 : states.script2;
}
